import { createFeatureSelector } from '@ngrx/store';

import { ChartsState } from 'app/main/charts/charts.reducer';

export const selectChartsState = createFeatureSelector<ChartsState>('charts');
